var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon Icon--xs mr-1 fill-black",
    style: {
      top: "-5px"
    },
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Phone icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26386 8.83989C6.28815 7.69501 5.28078 5.86631 5.30352 5.61415C5.30605 5.58611 5.80819 5.38527 6.20226 5.07693C6.40775 4.91615 6.68574 4.63874 6.90475 4.41001C7.1143 4.19118 7.14854 3.85613 6.9884 3.5978L5.0694 0.502855C4.7269 -0.049519 3.98254 -0.167237 3.49082 0.251753L2.21512 1.33879C0.936658 2.42818 0.626971 4.29026 1.47755 5.74846C2.41549 7.35644 2.74455 8.21104 4.90484 10.85C7.06511 13.489 7.86059 13.9462 9.2571 15.1634C10.5235 16.2672 12.3831 16.2809 13.6616 15.1915L14.9373 14.1045C15.4297 13.6849 15.4435 12.9201 14.9679 12.4822L12.2997 10.0257C12.077 9.82064 11.7461 9.79672 11.4975 9.96827C11.2377 10.1476 10.9204 10.3774 10.7288 10.555C10.3613 10.8955 10.0793 11.3629 10.0517 11.3605C9.80324 11.3395 8.23958 9.98475 7.26386 8.83989Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a8590987438404426be024e9649f40cd.svg";
export { ForwardRef as ReactComponent };